export default class Role {
  constructor(id = null, nome = null) {
    this.id = id
    this.nome = nome
  }
}
